import Caption from '@zenbusiness/common-components/Caption';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import PropTypes from 'prop-types';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const StyledSharedAsset = styled(SharedAsset)(({ theme }) => ({
  height: theme.spacing(16)
}));

const StepOnline = ({
  description,
  imageURL,
  stepCompleted
}) => (
  <Grid
    container
    direction="column"
    gap={2}
    sx={{
      textAlign: 'center',
      alignItems: 'center'
    }}
  >
    <StyledSharedAsset src={imageURL} />
    <CheckCircle sx={(theme) => ({
      width: theme.spacing(5),
      height: theme.spacing(5),
      color: stepCompleted
        ? theme.palette.growthBrand.light
        : theme.palette.focus20.main
    })}
    />
    <Caption size="lg" align="center" sx={{ whiteSpace: 'nowrap' }}>
      {description}
    </Caption>
  </Grid>
);

StepOnline.propTypes = {
  description: PropTypes.string.isRequired,
  imageURL: PropTypes.string.isRequired,
  stepCompleted: PropTypes.bool
};

export default StepOnline;
